export const PURCHASE = {
  ON_LIMITS_RECEIVED: 'PURCHASE.ON_LIMITS_RECEIVED',
};

export const onLimitsReceived = (limits) => ({
  type: PURCHASE.ON_LIMITS_RECEIVED,
  limits,
});
